/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Time_AfternoonInputs */

const en_ui_time_afternoon = /** @type {(inputs: Ui_Time_AfternoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afternoon`)
};

const de_ui_time_afternoon = /** @type {(inputs: Ui_Time_AfternoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`am Nachmittag`)
};

/**
* | output |
* | --- |
* | "Afternoon" |
*
* @param {Ui_Time_AfternoonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_time_afternoon = /** @type {((inputs?: Ui_Time_AfternoonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Time_AfternoonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_time_afternoon(inputs)
	return de_ui_time_afternoon(inputs)
});